<template>
    <b-modal
        :id="'add-assignment-part-modal-' + pageIn.id"
        :title="$t('assignment.add_part')"
        :ok-disabled="disabled"
        :ok-title="$t('common.add')"
        ok-variant="primary"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        @ok="onOk"
        @show="onShow"
        size="lg"
        modal-class="apprentice-default-modal">
        <!-- Choose a type -->
        <div class="select-type">
            <div class="row">
                <div class="col-12">
                    <h6 class="title">{{ $t('assignment.choose_part_type') }}</h6>
                </div>

                <div class="col-12 col-sm-6 assignment-type">
                    <div
                        class="assignment-type-explanation assignment-media-card apprentice-simple-card"
                        :class="type === 1 && 'active'">
                        <b-media>
                            <template #aside>
                                <i class="fad fa-comment btn btn-primary-icon-only icon"></i>
                            </template>
                            <h6 class="title">{{ $t('assignment.part.explanation') }}</h6>
                            <div class="description">
                                {{ $t('assignment.part.explanation_description') }}
                            </div>
                        </b-media>
                        <a
                            class="clickable"
                            href="#"
                            @click="type = 1"></a>
                    </div>
                </div>

                <div class="col-12 col-sm-6 assignment-type">
                    <div
                        class="assignment-type-assignment assignment-media-card apprentice-simple-card"
                        :class="type === 2 && 'active'">
                        <b-media>
                            <template
                                class="lee"
                                #aside>
                                <i class="fad fa-layer-plus btn btn-primary-icon-only icon"></i>
                            </template>
                            <h6 class="title">{{ $t('assignment.assignment') }}</h6>
                            <div class="description">{{ $t('assignment.part.assignment_description') }}</div>
                        </b-media>
                        <a
                            class="clickable"
                            href="#"
                            @click="type = 2"></a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Explanation type -->
        <div
            class="explanation-type-options"
            v-if="type === 1">
            <div class="row">
                <div class="col-12">
                    <h6 class="title">{{ $t('assignment.choose_explanation_type') }}</h6>
                </div>
                <div class="col-12 col-sm-4 explanation-type-option">
                    <div
                        class="explanation-type-text assignment-card apprentice-simple-card"
                        :class="explanationType === 1 && 'active'">
                        <div class="explanation-type-text-icon icon">
                            <i class="fad fa-comment-lines btn btn-primary-icon-only"></i>
                        </div>
                        <div class="explanation-type-text-content content">
                            <h6 class="title">{{ $t('common.text') }}</h6>
                        </div>
                        <a
                            class="clickable"
                            href="#"
                            @click="explanationType = 1"></a>
                    </div>
                </div>

                <div class="col-12 col-sm-4 explanation-type-option">
                    <div
                        class="explanation-type-image assignment-card apprentice-simple-card"
                        :class="explanationType === 2 && 'active'">
                        <div class="explanation-type-image-icon icon">
                            <i class="fad fa-images btn btn-primary-icon-only"></i>
                        </div>
                        <div class="explanation-type-image-content content">
                            <h6 class="title">{{ $t('assignment.part_type_images') }}</h6>
                        </div>
                        <a
                            class="clickable"
                            href="#"
                            @click="explanationType = 2"></a>
                    </div>
                </div>

                <div class="col-12 col-sm-4 explanation-type-option">
                    <div
                        class="explanation-type-video-file assignment-card apprentice-simple-card"
                        :class="explanationType === 3 && 'active'">
                        <div class="explanation-type-video-file-icon icon">
                            <i class="fad fa-video btn btn-primary-icon-only"></i>
                        </div>
                        <div class="explanation-type-video-file-content content">
                            <h6 class="title">{{ $t('assignment.part_type_video_upload') }}</h6>
                        </div>
                        <a
                            class="clickable"
                            href="#"
                            @click="explanationType = 3"></a>
                    </div>
                </div>

                <div class="col-12 col-sm-4 explanation-type-option">
                    <div
                        class="explanation-type-video-link assignment-card apprentice-simple-card"
                        :class="explanationType === 5 && 'active'">
                        <div class="explanation-type-video-link-icon icon">
                            <i class="fab fa-youtube btn btn-primary-icon-only"></i>
                        </div>
                        <div class="explanation-type-video-link-content content">
                            <h6 class="title">{{ $t('assignment.part_type_video_vimeo_link') }}</h6>
                        </div>
                        <a
                            class="clickable"
                            href="#"
                            @click="explanationType = 5"></a>
                    </div>
                </div>

                <div class="col-12 col-sm-4 explanation-type-option">
                    <div
                        class="explanation-type-attachment assignment-card apprentice-simple-card"
                        :class="explanationType === 4 && 'active'">
                        <div class="explanation-type-attachment-icon icon">
                            <i class="fad fa-paperclip btn btn-primary-icon-only"></i>
                        </div>
                        <div class="explanation-type-attachment-content content">
                            <h6 class="title">{{ $t('common.attachments') }}</h6>
                        </div>
                        <a
                            class="clickable"
                            href="#"
                            @click="explanationType = 4"></a>
                    </div>
                </div>

                <div class="col-12 col-sm-4 explanation-type-option">
                    <div
                        class="explanation-type-audio assignment-card apprentice-simple-card"
                        :class="explanationType === 6 && 'active'">
                        <div class="explanation-type-audio-icon icon">
                            <i class="fad fa-volume-up btn btn-primary-icon-only"></i>
                        </div>
                        <div class="explanation-type-audio-content content">
                            <h6 class="title">{{ $t('common.audio') }}</h6>
                        </div>
                        <a
                            class="clickable"
                            href="#"
                            @click="explanationType = 6"></a>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="assignment-type-options"
            v-if="type === 2">
            <div class="row">
                <div class="col-12">
                    <h6 class="title">{{ $t('assignment.choose_assignment_type') }}</h6>
                </div>
                <div class="col-6 col-sm-4 assignment-type-option">
                    <div
                        class="assignment-type-faq assignment-card apprentice-simple-card"
                        :class="assignmentType === 1 && 'active'">
                        <div class="assignment-type-faq-icon icon">
                            <i class="fad fa-comments btn btn-primary-icon-only"></i>
                        </div>
                        <div class="assignment-type-faq-content content">
                            <h6 class="title">{{ $t('assignment.part_type_question_answer') }}</h6>
                        </div>
                        <a
                            class="clickable"
                            href="#"
                            @click="assignmentType = 1"></a>
                    </div>
                </div>

                <div class="col-6 col-sm-4 assignment-type-option">
                    <div
                        class="assignment-type-attachment assignment-card apprentice-simple-card"
                        :class="assignmentType === 2 && 'active'">
                        <div class="assignment-type-attachment-icon icon">
                            <i class="fad fa-cloud-upload-alt btn btn-primary-icon-only"></i>
                        </div>
                        <div class="assignment-type-attachment-content content">
                            <h6 class="title">{{ $t('assignment.part_type_file_upload') }}</h6>
                        </div>
                        <a
                            class="clickable"
                            href="#"
                            @click="assignmentType = 2"></a>
                    </div>
                </div>

                <div class="col-6 col-sm-4 assignment-type-option">
                    <div
                        class="assignment-type-text assignment-card apprentice-simple-card"
                        :class="assignmentType === 3 && 'active'">
                        <div class="assignment-type-text-icon icon">
                            <i class="fad fa-align-left btn btn-primary-icon-only"></i>
                        </div>
                        <div class="assignment-type-text-content content">
                            <h6 class="title">{{ $t('assignment.part_type_short_report') }}</h6>
                        </div>
                        <a
                            class="clickable"
                            href="#"
                            @click="assignmentType = 3"></a>
                    </div>
                </div>

                <div class="col-6 col-sm-4 assignment-type-option">
                    <div
                        class="assignment-type-editor assignment-card apprentice-simple-card"
                        :class="assignmentType === 4 && 'active'">
                        <div class="assignment-type-editor-icon icon">
                            <i class="fad fa-file-word btn btn-primary-icon-only"></i>
                        </div>
                        <div class="assignment-type-editor-content content">
                            <h6 class="title">{{ $t('assignment.part_type_editor_report') }}</h6>
                        </div>
                        <a
                            class="clickable"
                            href="#"
                            @click="assignmentType = 4"></a>
                    </div>
                </div>

                <div class="col-6 col-sm-4 assignment-type-option">
                    <div class="assignment-type-fill-in-the-blanks assignment-card apprentice-simple-card"
                         :class="assignmentType === 8 && 'active'">
                        <div class="assignment-type-fill-in-the-blanks-icon icon">
                            <i class="fad fa-comment-dots btn btn-primary-icon-only"></i>
                        </div>
                        <div class="assignment-type-fill-in-the-blanks-content content">
                            <h6 class="title">{{ $t('assignment.part_type_fill_in_the_blanks')}}</h6>
                        </div>
                        <a class="clickable" href="#" @click="assignmentType = 9"></a>
                    </div>
                </div>

                <div class="col-6 col-sm-4 assignment-type-option">
                    <div
                        class="assignment-type-choice-list assignment-card apprentice-simple-card"
                        :class="assignmentType === 99 && 'active'">
                        <div class="assignment-type-choice-list-icon icon">
                            <i class="fad fa-list-ol btn btn-primary-icon-only"></i>
                        </div>
                        <div class="assignment-type-choice-list-content content">
                            <h6 class="title">{{ $t('assignment.part_type_choice_list') }}</h6>
                        </div>
                        <a
                            class="clickable"
                            href="#"
                            @click="assignmentType = 99"></a>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="assignment-type-list-options"
            v-if="assignmentType === 99">
            <div class="row assignment-type-list-options-wrapper">
                <div class="col-12">
                    <h6 class="title">Kies een keuzelijst</h6>
                </div>
                <div class="col-6 col-sm-4 assignment-type-list-option">
                    <div
                        class="list-choice-default-type assignment-card apprentice-simple-card"
                        :class="listType === 5 && 'active'">
                        <div class="list-choice-default-type-icon icon">
                            <i class="fad fa-clipboard-list-check btn btn-primary-icon-only"></i>
                        </div>
                        <div class="list-choice-default-type-content content">
                            <h6 class="title">{{ $t('assignment.part_type_default_choice_list') }}</h6>
                        </div>
                        <a
                            class="clickable"
                            href="#"
                            @click="listType = 5"></a>
                    </div>
                </div>

                <div class="col-6 col-sm-4 assignment-type-list-option">
                    <div
                        class="list-choice-color-type assignment-card apprentice-simple-card"
                        :class="listType === 6 && 'active'">
                        <div class="list-choice-color-type-icon icon">
                            <i class="fad fa-palette btn btn-primary-icon-only"></i>
                        </div>
                        <div class="list-choice-color-type-content content">
                            <h6 class="title">{{ $t('assignment.part_type_colors_choice_list') }}</h6>
                        </div>
                        <a
                            class="clickable"
                            href="#"
                            @click="listType = 6"></a>
                    </div>
                </div>

                <div class="col-6 col-sm-4 assignment-type-list-option">
                    <div
                        class="list-choice-checkbox-type assignment-card apprentice-simple-card"
                        :class="listType === 7 && 'active'">
                        <div class="list-choice-checkbox-type-icon icon">
                            <i class="fad fa-ballot-check btn btn-primary-icon-only"></i>
                        </div>
                        <div class="list-choice-checkbox-type-content content">
                            <h6 class="title">{{ $t('assignment.part_type_checkboxes') }}</h6>
                        </div>
                        <a
                            class="clickable"
                            href="#"
                            @click="listType = 7"></a>
                    </div>
                </div>


                <div class="col-6 col-sm-4 assignment-type-list-option">
                    <div class="list-match-type assignment-card apprentice-simple-card"
                         :class="listType === 8 && 'active'">
                        <div class="list-match-type-icon icon">
                            <i class="fad fa-random btn btn-primary-icon-only"></i>
                        </div>
                        <div class="list-match-type-content content">
                            <h6 class="title">{{ $t('assignment.part_type_match')}}</h6>
                        </div>
                        <a class="clickable" href="#" @click="listType = 8"></a>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="assignment-part-title"
            v-if="type === 2 && assignmentType !== null">
            <b-alert
                v-if="hasError"
                variant="danger"
                show>
                {{ errorMessage }}
            </b-alert>
            <b-form-group
                label="Titel"
                label-for="assignment-title-input">
                <b-form-input
                    id="assignment-title-input"
                    v-model="name"
                    :placeholder="$t('assignment.title_placeholder_part')"></b-form-input>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-lesson-module-assignment-add-part-modal-component',
    props: ['pageIn'],
    data() {
        return {
            type: null,
            name: null,
            typeOptions: [
                { text: this.$t('assignment.part_type_explanation'), value: 1 },
                { text: this.$t('assignment.part_type_assignment'), value: 2 },
            ],
            explanationType: null,
            explanationOptions: [
                { text: this.$t('assignment.part_type_text'), value: 1 },
                { text: this.$t('assignment.part_type_images'), value: 2 },
                { text: this.$t('assignment.part_type_video_upload'), value: 3 },
                { text: this.$t('assignment.part_type_video_vimeo_link'), value: 5 },
                { text: this.$t('assignment.part_type_attachments'), value: 4 },
                { text: this.$t('assignment.part_type_audio_upload'), value: 6 },
            ],
            assignmentType: null,
            assignmentOptions: [
                { text: this.$t('assignment.part_type_question_answer'), value: 1 },
                { text: this.$t('assignment.part_type_file_upload'), value: 2 },
                { text: this.$t('assignment.part_type_short_report'), value: 3 },
                { text: this.$t('assignment.part_type_editor_report'), value: 4 },
                { text: this.$t('assignment.part_type_fill_in_the_blanks'), value: 9 },
                { text: this.$t('assignment.part_type_choice_list'), value: 99 }, // contains value 5, 6, 7 and 8
            ],
            listType: null,
            listTypeOptions: [
                { text: this.$t('assignment.part_type_default_choice_list'), value: 5 },
                { text: this.$t('assignment.part_type_colors_choice_list'), value: 6 },
                { text: this.$t('assignment.part_type_checkboxes'), value: 7 },
                { text: this.$t('assignment.part_type_match'), value: 8 },
            ],
            hasError: false,
            errorMessage: '',
        };
    },
    computed: {
        subType() {
            if (this.type === 1) {
                return this.explanationType;
            }
            if (this.type === 2) {
                return this.assignmentType !== 99 ? this.assignmentType : this.listType;
            }
            return null;
        },
        disabled() {
            if (!this.type) {
                return true;
            }
            if (!this.subType) {
                return true;
            }
            return false;
        },
    },
    methods: {
        onOk(bvModalEvent) {
            this.checkForErrors();

            if (this.hasError) {
                bvModalEvent.preventDefault();
                return;
            }
            this.alert.saving(this.$t('assignment.add_part'), this.$t('assignment.part_saving'));

            let data = {
                type: this.type,
                sub_type: this.subType,
                page_id: this.pageIn.id,
                sub_assignment_id: this.pageIn.sub_assignment_id,
                order: this.pageIn.parts.length + 1,
                name: this.name,
            };

            this.axios.post(this.routes.assignmentPart(), data).then(
                (response) => {
                    this.$emit('part-added', response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        onShow() {
            this.type = null;
            this.explanationType = null;
            this.assignmentType = null;
            this.name = null;
            this.listType = null;
            this.hasError = false;
        },

        checkForErrors() {
            this.hasError = false;

            if (this.name && this.name.length > 192) {
                this.hasError = true;
                this.errorMessage = this.$t('assignment.part_title_max_characters');
            }
        },
    },
};
</script>

<style scoped lang="scss">
.select-type {
    .title {
        font-weight: $font-weight-bold;
    }
}

.assignment-type {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.assignment-media-card {
    height: 100%;
    position: relative;
    background-color: $secondary-background-color;
    border: 2px solid transparent;

    .icon {
        display: flex;
        align-content: center;
        justify-content: center;
        line-height: 1;
        text-align: center;
        font-size: 4rem;
    }

    .title {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
        font-weight: $font-weight-bold;
    }

    .description {
        color: $text-muted-color;
        line-height: 1.3;
        text-align: left;
    }

    &.active {
        border: 2px solid $primary;
    }

    &:hover {
        cursor: pointer;
        box-shadow: 1px 0px 4px $border-color;
        border: 2px solid $primary;

        .icon {
            color: var(--primaryLightest);
        }
    }
}

.assignment-card {
    height: 100%;
    position: relative;
    background-color: $secondary-background-color;
    border: 2px solid transparent;

    .icon {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

        i {
            display: flex;
            align-content: center;
            justify-content: center;
            line-height: 1;
            text-align: center;
            font-size: 4rem;
        }
    }

    .content {
        .title {
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
            font-weight: $font-weight-bold;
        }

        .description {
            color: $text-muted-color;
            line-height: 1.3;
            text-align: left;
        }
    }

    &.active {
        border: 2px solid $primary;
    }

    &:hover {
        cursor: pointer;
        box-shadow: 1px 0px 4px $border-color;
        border: 2px solid $primary;

        .icon {
            i {
                color: var(--primaryLightest);
            }
        }
    }
}

.explanation-type-options,
.assignment-type-options,
.assignment-type-list-options {
    margin-top: map-get($grid-gutter-spacing, 'forty-two');

    .assignment-type-option,
    .explanation-type-option {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    }

    .title {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
        font-weight: $font-weight-bold;
    }

    .assignment-card {
        .icon {
            i {
                font-size: 3rem;
            }
        }

        .title {
            margin-bottom: 0;
            font-size: $default-font-size;
        }
    }
}

.assignment-part-title {
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
}

.assignment-type-list-options-wrapper {
    row-gap: $grid-gutter-width
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .assignment-type {
        margin-bottom: 0;
    }
}
</style>
